/* ============================================================
   Versandkostenfrei-Leiste  ·  assets/free-shipping-bar.js

   Grundsatz: die Leiste wird serverseitig in Liquid gerendert und
   ist damit beim Seitenaufruf immer korrekt. Dieses Skript ist nur
   die Absicherung fuer Themes, die den Warenkorb per AJAX
   aktualisieren, ohne die Section neu zu rendern.

   Bewusst NICHT verwendet: Ueberschreiben von window.fetch.
   Stattdessen PerformanceObserver (nur lesend) + Custom Events.
   ============================================================ */

(function () {
  'use strict';

  if (window.customElements && customElements.get('free-shipping-bar')) return;

  var instances = new Set();
  var syncTimer = null;

  /* ---------- Geldformatierung nach Shopify money_format ---------- */

  function group(number, decimals, thousandSep, decimalSep) {
    var parts = Math.abs(number).toFixed(decimals).split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep);
    return decimals ? intPart + decimalSep + parts[1] : intPart;
  }

  function formatMoney(cents, format) {
    var value = (cents || 0) / 100;
    var f = format && format.indexOf('{{') !== -1 ? format : '{{amount_with_comma_separator}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return group(value, 2, ',', '.');
        case 'amount_no_decimals': return group(value, 0, ',', '.');
        case 'amount_with_comma_separator': return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(value, 0, '.', ',');
        case 'amount_with_space_separator': return group(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return group(value, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return group(value, 2, "'", '.');
        default: return group(value, 2, '.', ',');
      }
    });
  }

  /* ---------- Custom Element ---------- */

  class FreeShippingBar extends HTMLElement {
    connectedCallback() {
      this.textEl = this.querySelector('[data-fsb-text]');
      this.trackEl = this.querySelector('[data-fsb-track]');
      this.fillEl = this.querySelector('[data-fsb-fill]');
      instances.add(this);
      scheduleSync(200);
    }

    disconnectedCallback() {
      instances.delete(this);
    }

    update(cart) {
      var threshold = parseInt(this.dataset.threshold, 10) || 0;
      if (!threshold) return;

      var value = this.dataset.basis === 'subtotal'
        ? (cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price)
        : cart.total_price;

      var remaining = Math.max(0, threshold - value);
      var percent = Math.min(100, (value / threshold) * 100);
      var reached = remaining === 0;

      if (this.fillEl) this.fillEl.style.width = percent.toFixed(2) + '%';
      if (this.trackEl) this.trackEl.setAttribute('aria-valuenow', String(Math.round(percent)));
      this.classList.toggle('fsb--reached', reached);

      if (this.textEl) {
        while (this.textEl.firstChild) this.textEl.removeChild(this.textEl.firstChild);

        if (reached) {
          this.textEl.appendChild(document.createTextNode(this.dataset.success || ''));
        } else {
          var parts = (this.dataset.message || '').split('[amount]');
          this.textEl.appendChild(document.createTextNode(parts[0]));
          if (parts.length > 1) {
            var strong = document.createElement('strong');
            strong.className = 'fsb__amount';
            strong.textContent = formatMoney(remaining, this.dataset.moneyFormat);
            this.textEl.appendChild(strong);
            this.textEl.appendChild(document.createTextNode(parts.slice(1).join('[amount]')));
          }
        }
      }

      if (this.dataset.hideEmpty === 'true') {
        this.hidden = (cart.item_count || 0) === 0;
      }
    }
  }

  /* ---------- Synchronisation ---------- */

  function sync() {
    if (!instances.size) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (cart) {
        instances.forEach(function (el) { el.update(cart); });
      })
      .catch(function () { /* Leiste bleibt auf dem serverseitig gerenderten Stand */ });
  }

  function scheduleSync(delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, delay || 250);
  }

  /* Warenkorb-Requests erkennen, ohne window.fetch zu ueberschreiben */
  if ('PerformanceObserver' in window) {
    try {
      var po = new PerformanceObserver(function (list) {
        var entries = list.getEntries();
        for (var i = 0; i < entries.length; i++) {
          if (/\/cart\/(add|change|update|clear)/.test(entries[i].name)) {
            scheduleSync(300);
            return;
          }
        }
      });
      po.observe({ type: 'resource', buffered: true });
    } catch (e) { /* aeltere Browser: Custom Events reichen */ }
  }

  /* Gaengige Theme-Events */
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build', 'cart-drawer:open']
    .forEach(function (evt) {
      document.addEventListener(evt, function () { scheduleSync(120); });
    });

  /* Theme-Editor und Zurueck-Navigation (bfcache) */
  document.addEventListener('shopify:section:load', function () { scheduleSync(120); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) scheduleSync(0); });

  /* Manueller Haken, falls das Theme ein eigenes Event nutzt:
     window.freeShippingBarRefresh() im Theme-JS nach dem Cart-Update aufrufen. */
  window.freeShippingBarRefresh = function () { scheduleSync(0); };

  customElements.define('free-shipping-bar', FreeShippingBar);
})();